module.exports = __webpack_public_path__ + "static/media/img02.af89356b.png";